//eslint-disable-next-line  @typescript-eslint/no-namespace
export declare namespace API {
  export interface BaseResponse {
    status: number;
  }

  export interface Item {
    id: number;
    file_name: string;
    created_at: string;
    toshiba_prediction_id?: number;
  }

  export interface Prop {
    url: string;
    token: string;
    custom: object;
  }

  export interface ItemDetail extends Item {
    data_healths: object;
  }

  export interface ItemDetailResponse extends BaseResponse {
    id: number;
    body: ItemDetail;
  }

  export interface getAll extends BaseResponse {
    body: {
      total: number;
      count: number;
      rows: Item[];
    };
  }

  //=========== AI ==========
  export interface PredictRequest {
    health_check_id: number;
    health_check_type: number; // 1: PO, 2: User
  }

  export interface PredictResponse extends ResultResponse {}

  export interface AiInfo {
    k: string;
    v: string;
    u?: string;
    isNeedUpdate?: boolean;
    errorCodesForRequiredField?: string[];
    errorCodesForInvalidRange?: string[];
    min?: number;
    max?: number;
    errorMessage?: string;
    defaultValue?: string;
  }

  export interface ResultTab {
    key: string;
    title: string;
    data?: number[];
    probability?: string;
    disease?: string;
    legend?: string;
    advice?: string;
  }

  export interface ResultChart {
    x: number;
    y?: number;
  }

  export interface ResultRequest {
    id: number;
  }

  export interface ResultAdviceResponse {
    got?: string;
    ldl?: string;
    sbp?: string;
    hba1c?: string;
    scr?: string;
    tg?: string;
    hdl?: string;
    rgtp?: string;
    dbp?: string;
  }

  export interface ResultPredictionResponse {
    ldl?: number[];
    bmi?: number[];
    scr?: number[];
    tg?: number[];
    hdl?: number[];
    sbp?: number[];
    dbp?: number[];
    gpt?: number[];
    got?: number[];
    rgtp?: number[];
    hba1c?: number[];
  }

  export interface ResultResponse extends BaseResponse {
    body: {
      toshiba_prediction_id?: number;
      prediction: ResultPredictionResponse;
      advice?: ResultAdviceResponse;
      // need show advice - prefix x
      // ldl?: number[];
      // bmi?: number[];
      // scr?: number[]x;
      // tg?: number[];
      // hdl?: number[]x;
      // sbp?: number[];
      // dbp?: number[]x;
      // gpt?: number[];
      // got?: number[]x;
      // rgtp?: number[];
      // hba1c?: number[] x;
      // toshiba_prediction_id?: number;
      // advice?: ResultAdviceResponse;
    };
  }

  //=========== BAR DATE ==========
  export interface BarDateItem {
    text: string;
    isPicked: boolean;
    index: number;
  }

  //=========== INIT ROUTE ==========
  export interface InitRoute {
    initPage: string;
    id?: number;
  }

  //=========== DATA HEALTH ==========
  type KeyStringType = {
    [k: string]: string | undefined;
  };

  export interface DataHealths extends KeyStringType {
    sex?: string;
    age?: string;
    red_blood_cells_num?: string;
    hemoglobin_content?: string;
    got_ast?: string;
    gpt_alt?: string;
    y_gpt?: string;
    creatinine?: string;
    fasting_blood_glucose?: string;
    hba1c?: string;
    neutral_fat?: string;
    hdl_cholesterol?: string;
    ldl_cholesterol?: string;
    maximum_blood_pressure?: string;
    minimum_blood_pressure?: string;
    height?: string;
    body_weight?: string;
    bmi?: string;
    waist_circum?: string;
  }

  //=========== ADVICES ==========
  // API
  // advices
  export interface ReadAdvicesRequest {
    id: number;
  }

  export interface ReadAdvicesResponse extends BaseResponse {
    body: {
      advice?: ReadAdvicesRecordResponse[];
    };
  }

  export interface ReadAdvicesRecordResponse {
    toshiba_advice_id: number;
    advice: string;
    status: boolean;
    type: string;
    reactions: number;
  }

  // reaction
  export interface CreateReactionRequest {
    reactions: number;
    toshiba_advice_id: number;
  }

  export interface CreateReactionResponse {}

  // delete
  export interface DeleteRecordRequest {
    id: number;
  }

  export interface DeleteRecordResponse {}

  // UI
  // advices
  export interface ResultAdvicesModel {
    got?: ReadAdvicesRecordResponse[];
    ldl?: ReadAdvicesRecordResponse[];
    sbp?: ReadAdvicesRecordResponse[];
    hba1c?: ReadAdvicesRecordResponse[];
    scr?: ReadAdvicesRecordResponse[];
    tg?: ReadAdvicesRecordResponse[];
    hdl?: ReadAdvicesRecordResponse[];
    rgtp?: ReadAdvicesRecordResponse[];
    dbp?: ReadAdvicesRecordResponse[];
  }
}

export enum ReactionView {
  LIKE = 1,
  DISLIKE = 2,
}

export enum Reaction {
  UNKNOWN = 0,
  LIKE = 1,
  DISLIKE = 2,
}
